<template>
  <!-- 头部 -->
  <Layout>
    <template #header> 原地掉头 </template>
    <!-- 主体 -->
    <template #default>
      <div class="row q-col-gutter-x-md full-height">
        <div
          class="col-4 col-xs-12 col-sm-4 justify-around left-column road-pattern"
          style="text-align: center; font-size: 20px"
        >
          <!-- 左侧文字 -->
          <q-card bordered class="full-height column">
            <q-card-section class="row">
              <ToggleSwitch
                v-model="functionSwitch"
                color="#4caf50"
                true-value="功能开启"
                false-value="功能关闭"
              >
              </ToggleSwitch>
            </q-card-section>
            <!-- <q-toggle
              v-model="functionSwitch"
              checked-icon="check"
              color="green"
              unchecked-icon="clear"
              false-value="功能关闭"
              true-value="功能开启"
              size="xl"
            /> -->
            <q-card-section class="row justify-center" style="flex: 1">
              <div class="road-pattern-btn">
                <div
                  v-for="(item, index) in roadPatterns"
                  :key="index"
                  class="road-pattern-btn-item"
                  @click="handleRoadChange(index)"
                >
                  <q-btn
                    :disabled="functionSwitch !== '功能开启'"
                    glossy
                    :color="
                      functionSwitch !== '功能开启' || item.isChecked == false
                        ? 'grey-5'
                        : 'green-7'
                    "
                    :label="item.text"
                    size="lg"
                    :text-color="
                      functionSwitch !== '功能开启' || item.isChecked == false
                        ? 'black'
                        : 'grey-1'
                    "
                  />
                </div>
              </div>
              <div
                style="
                  width: 90%;
                  height: 200px;
                  text-align: left;
                  margin-left: 40px;
                  margin-bottom: 30px;
                "
              >
                <div style="display: flex; height: 70px">
                  <img
                    :src="
                      UIRx_VehSpd < 1 || UIRx_TAAAct === 1 ? 正确 : 错误提示
                    "
                    style="width: 40px; height: 40px; margin-right: 30px"
                  />车辆静止
                </div>
                <div
                  style="
                    display: flex;

                    height: 70px;
                  "
                >
                  <img
                    :src="
                      Math.abs(UIRx_SBW_HWAAng) > 300 || UIRx_TAAAct === 1
                        ? 正确
                        : 错误提示
                    "
                    style="width: 40px; height: 40px; margin-right: 30px"
                  />
                  打满方向
                </div>
                <div
                  style="
                    display: flex;

                    height: 70px;
                  "
                >
                  <img
                    :src="
                      UIRx_ActuGearSta === 3 || UIRx_TAAAct === 1
                        ? 正确
                        : 错误提示
                    "
                    style="width: 40px; height: 40px; margin-right: 30px"
                  />档位D档
                </div>
                <div
                  style="
                    display: flex;

                    height: 70px;
                  "
                >
                  <img
                    :src="
                      (UIRx_AccelPdlPos >= 10 &&
                        UIRx_BrkPdlPositionAct === 0) ||
                      UIRx_TAAAct === 1
                        ? 正确
                        : 错误提示
                    "
                    style="width: 40px; height: 40px; margin-right: 30px"
                  />
                  脚踩油门
                </div>
              </div>
            </q-card-section>
          </q-card>
        </div>
        <div class="col-8 col-xs-12 col-sm-8 right-column">
          <q-card bordered class="column full-height card-style">
            <!-- <p
              :style="UIRx_TAAAct === 1 ? 'color:#1da57a' : ' color:#000'"
              style="margin-top: 35px"
            >
              请踩制动激活AVH，车辆静止后，打满方向，D档，松制动后踩油门开始原地掉头
            </p> -->
            <div class="charts-container relative-position">
              <!-- 旋转角度 -->
              <!-- <div
                :style="{
                  position: 'absolute',
                  top: '-40px',
                  left: '-105px',
                  fontSize: '26px',
                  width: '240px',
                  height: '40px',
                  backgroundColor: 'rgba(255, 255, 255, 0.2)',
                  borderRadius: '10px',
                  display: 'flex',
                }"
              >
                <div style="width: 140px">旋转角度：</div>
                <div style="width: 100px">
                  {{ hwaangLoading > 0 ? "左" : hwaangLoading === 0 ? "右" : ""
                  }}<span style="margin-left: 10px">{{
                    `${Math.round(newRotateAngle * 0.06)}°`
                  }}</span>
                </div>
              </div> -->
              <div
                :style="{
                  transform: 'rotate(0deg)',
                }"
                class="charts-style"
              >
                <Charts :options="option" ref="charts" />
                <div class="cross-arrow">
                  <div class="arrow-line1"></div>
                  <div class="arrow-line2"></div>
                </div>
              </div>
              <div
                style="
                  width: 500px;
                  height: 500px;
                  position: absolute;
                  top: 13.9%;
                  left: 13.9%;
                "
              >
                <p style="position: relative; top: -120px; right: 65px">0°</p>
                <p style="position: relative; top: 120px; right: -230px">90°</p>
                <p style="position: relative; top: 360px; right: 75px">180°</p>
                <p style="position: relative; top: 30px; right: 375px">90°</p>
              </div>
              <q-img
                :fit="'contain'"
                v-if="hwaangLoading === 0 && functionSwitch === '功能开启'"
                :src="L系列_顶视_01_白色"
                spinner-color="white"
                style="width: 130px; height: 155px;"
                class="img"
                :style="{
                  transform:
                    UIRx_TAAAct === 1 && functionSwitch === '功能开启'
                      ? `rotate(${-rotateAngle * 0.06}deg)`
                      : 'rotate(0deg)',
                  transformOrigin: '50px 85%',
                }"
              >
              </q-img>
              <q-img
                :fit="'contain'"
                v-if="hwaangLoading > 0 && functionSwitch === '功能开启'"
                :src="L系列_顶视_01_白色"
                spinner-color="white"
                style="width: 130px; height: 155px;"
                class="img2"
                :style="{
                  transform:
                    UIRx_TAAAct === 1 && functionSwitch === '功能开启'
                      ? `rotate(${-rotateAngle * 0.06}deg)`
                      : 'rotate(0deg)',
                  transformOrigin: '90px 85%',
                }"
              ></q-img>
              <!-- 左上角图片 -->
              <!-- <q-img
                v-if="hwaangLoading > 0 && functionSwitch === '功能开启'"
                :src="answerpng"
                spinner-color="white"
                class="answer"
              />
              <q-img
                v-if="hwaangLoading === 0 && functionSwitch === '功能开启'"
                :src="answerpng"
                spinner-color="white"
                class="answer2"
              /> -->
            </div>
          </q-card>
        </div>
      </div>
    </template>
  </Layout>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import Charts from "@/components/Charts";
import { getChartsDefaultOptions } from "./helper/taa";
import { SERVICE } from "@/services/domainControl/define";
import Layout from "./components/Layout.vue";
import { NOTIFY } from "@/services/domainControl/taa";
import { useDomainControlStore } from "@/stores/domainControl";
import useInitialize from "@/composables/domainControl/useInitialize";
import { onBeforeRouteLeave } from "vue-router";
import { useQuasar } from "quasar";
import L系列_顶视_01_白色 from "@/assets/img/L系列_顶视_蓝色.png";
import 湿瓷砖平地 from "@/assets/img/湿瓷砖平地.jpg";
import 湿玄武平地 from "@/assets/img/湿玄武平地.jpg";
import 正确 from "@/assets/img/正确.png";
import 错误提示 from "@/assets/img/错误提示.png";
import ToggleSwitch from "@/components/ToggleSwitch";
// 用于跟踪当前选中的按钮索引
const functionSwitch = ref("功能关闭");

// 红色圆心
const redCircle = ref(false);
const newRotateAngle = ref(0);
// 图表配置
const option = ref(
  getChartsDefaultOptions(redCircle.value, newRotateAngle.value * 0.06)
);
const charts = ref();

// 数据存储
const domainControlStore = useDomainControlStore();

// 路面选择项
const roadPatterns = ref([
  { src: 湿瓷砖平地, text: "湿瓷砖平地", isChecked: false },
  { src: 湿玄武平地, text: "湿玄武平地", isChecked: false },
]);

// 当前 TAA 功能的活动状态
const UIRx_TAAAct = ref(0);

// 加载状态，用于显示不同的图像
const hwaangLoading = ref(2);

// 当前旋转角度
const rotateAngle = ref(0);

// 上一次的旋转角度
const oldRotateAngle = ref(0);

// 新的旋转角度

const UIRx_VehSpd = ref(0);
const UIRx_SBW_HWAAng = ref(0);
const UIRx_ActuGearSta = ref(0);
const UIRx_AccelPdlPos = ref(0);
const UIRx_BrkPdlPositionAct = ref(0);

// 处理通知数据
const handleNotify = (data: DomianControl.TAANotifyData) => {
  UIRx_TAAAct.value = data.UIRx_TAAAct; // 更新 TAA 功能的活动状态
  UIRx_VehSpd.value = data.UIRx_VehSpd;
  UIRx_SBW_HWAAng.value = data.UIRx_SBW_HWAAng;
  UIRx_ActuGearSta.value = data.UIRx_ActuGearSta;
  UIRx_AccelPdlPos.value = data.UIRx_AccelPdlPos;
  UIRx_BrkPdlPositionAct.value = data.UIRx_BrkPdlPositionAct;
  if (functionSwitch.value === "功能开启") {
    if (UIRx_TAAAct.value === 1) {
      redCircle.value = true; // 设置红色圆心为 true
      rotateAngle.value = oldRotateAngle.value + data.UIRx_ACUYawRate;
      oldRotateAngle.value = rotateAngle.value; // 更新上一次的旋转角度
      newRotateAngle.value = oldRotateAngle.value + data.UIRx_ACUYawRate; // 更新新的旋转角度
    } else {
      redCircle.value = false; // 设置红色圆心为 false
      rotateAngle.value = 0; // 重置旋转角度
      newRotateAngle.value = 0; // 重置新的旋转角度
      oldRotateAngle.value = 0;
    }
    hwaangLoading.value =
      data.UIRx_SBW_HWAAng > 0 ? 1 : data.UIRx_SBW_HWAAng < 0 ? 0 : 2;
  } else {
    oldRotateAngle.value = 0;
    rotateAngle.value = 0;
    newRotateAngle.value = 0;
  }
};

// 解析输出值
const parseOutputValue = (value: DomianControl.OutputValue) => {
  // console.log("[BOWEN_LOG] 🚀 ~~ parseOutputValue ~~ value:", value);
};

// 监听 redCircle 的变化
watch([redCircle, newRotateAngle], ([newRedCircle, newRotateAngle]) => {
  option.value = getChartsDefaultOptions(newRedCircle, newRotateAngle * 0.06);
});
// watch(redCircle, (newValue) => {
//   option.value = getChartsDefaultOptions(newValue);
// });
// 初始化
useInitialize({
  handleNotify,
  SERVICE_UUID: SERVICE.uuid,
  NOTIFY_UUID: NOTIFY.uuid,
  parseOutputValue: parseOutputValue,
});

// 处理路面选择变化
const handleRoadChange = (index: number) => {
  if (functionSwitch.value !== "功能开启") return;

  roadPatterns.value.forEach((item, idx) => {
    item.isChecked = idx === index;
  });

  const value = functionSwitch.value === "功能开启" ? 1 : 0;
  domainControlStore.writeOutputValue({
    UITx_TAA_ModeSelect: index,
    UITx_TAA_Ena: value,
  });
};

// 监听 functionSwitch 变化
watch(functionSwitch, (newValue, oldValue) => {
  if (newValue !== oldValue) {
    const value = newValue === "功能开启" ? 1 : 0;

    if (newValue === "功能关闭") {
      domainControlStore.writeOutputValue({
        UITx_TAA_ModeSelect: 0,
        UITx_TAA_Ena: value,
      });

      roadPatterns.value.forEach((item) => {
        item.isChecked = false;
      });

      oldRotateAngle.value = 0;
      rotateAngle.value = 0;
      newRotateAngle.value = 0;
    }
  }
});

// 监听 UIRx_TAAAct 变化
watch(UIRx_TAAAct, (newValue) => {
  if (newValue === 0) {
    rotateAngle.value = 0;
  }
});

// 路由离开前的检查
onBeforeRouteLeave((to, from) => {
  domainControlStore.writeOutputValue({
    UITx_TAA_Ena: 0,
    UITx_TAA_ModeSelect: 0,
  });
});
</script>

<style scoped>
.road-pattern-text {
  font-size: 30px;
  width: 20%;
  writing-mode: vertical-rl;
  /* 文字间隔 */
  letter-spacing: 10px;
  margin: 0 !important;
}

.road-pattern-btn {
  width: 90%;
  display: flex;
  justify-content: space-around;
  height: 50px;
  margin-top: 60px;
}

.road-pattern-btn-item {
  width: 40%;
  margin: 0 auto;
  margin-bottom: 60px;

  p {
    font-size: 20px;
    text-align: center;
    padding: 10px;
    background-color: #1e201d99;
    border-radius: 0px 0px 5px 5px;
  }
}

.road-pattern-btn-item-img {
  width: 100%;
  height: 100px;
  border-radius: 5px 5px 0px 0px;
}

.charts-container {
  width: 500px;
  height: 500px;
  margin: auto;
  position: relative;
}

.chart-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.charts-style {
  width: 100%;
  height: 100%;
  /* 转动出现动画效果 */
  transition: all 1s ease;
}

.cross-arrow {
  width: 358px;
  height: 358px;
  position: absolute;
  top: 13.9%;
  left: 14.1%;
  /* 置于底层 */
  z-index: -1;
  /* transition: all 1s ease; */
  /* 虚线 */

  /* background-color: rgba(169, 169, 169, 0.8); */
}

.arrow-line1,
.arrow-line2 {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.7);
  /* border-style:dotted; */
}

.arrow-line1 {
  top: 50%;
  left: 0;
  width: 100%;
  height: 3px;
}

.arrow-line2 {
  top: 0;
  left: 50%;
  width: 4px;
  height: 100%;
}

/* 北面箭头 */
.arrow-line2::before {
  content: "";
  position: absolute;
  top: -7px;
  left: -2px;
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 10px solid rgba(0, 0, 0, 0.7);
}

/* 东面箭头 */
.arrow-line1::before {
  content: "";
  position: absolute;
  top: -2px;
  right: -7px;
  width: 0;
  height: 0;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-left: 10px solid rgba(0, 0, 0, 0.7);
}

/* 南面箭头 */
.arrow-line2::after {
  content: "";
  position: absolute;
  bottom: -7px;
  left: -2px;
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 10px solid rgba(0, 0, 0, 0.7);
}

/* 西面箭头 */
.arrow-line1::after {
  content: "";
  position: absolute;
  top: -2px;
  left: -7px;
  width: 0;
  height: 0;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-right: 10px solid rgba(0, 0, 0, 0.7);
}
.img {
  position: absolute;
  top: 120px;
  left: 210px;
  z-index: 999;
}

.img2 {
  position: absolute;
  top: 120px;
  left: 155px;
  z-index: 999;
}

.road-pattern-btn-item-img.grayscale {
  -webkit-filter: grayscale(100%);
}

.road-pattern-btn-item p.disabled {
  background-color: rgba(169, 169, 169, 0.8);
}

.placeholder {
  height: 60px;
  line-height: 60px;
}

.select-mode {
  margin: 0;
  height: 60px;
  line-height: 60px;
}

.shadow {
  box-shadow: 5px 5px 5px #181818;
  /* transform: scale(1); */
  color: #1da57a;
}

.answer {
  transform: rotateX(180deg) rotate(50deg);
  width: 80px;
  height: 50px;
  position: absolute;
  top: 30px;
  left: 110px;
  z-index: 100;
  animation: bounce 1s infinite;
  /* 图片颜色 */
  filter: invert(70%);
}

.answer2 {
  transform: rotateX(180deg) rotateY(180deg) rotate(50deg);
  width: 80px;
  height: 50px;
  position: absolute;
  top: 30px;
  right: 110px;
  z-index: 100;
  animation: bounce2 1s infinite;
  filter: invert(70%);
}
.green-text {
  color: #1da57a;
}

.charts-style {
  /* 转动出现动画效果 */
  transition: all 1s ease;
}

.span-green {
  color: #1da57a;
}

.card-style {
  text-align: center;
  font-size: 20px;
  margin: auto;
}
.rotate {
  animation: spin 5s linear infinite;
}

@keyframes spin {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
</style>
